import { render, staticRenderFns } from "./LandingContent.vue?vue&type=template&id=0b40d768"
import script from "./LandingContent.vue?vue&type=script&lang=js"
export * from "./LandingContent.vue?vue&type=script&lang=js"
import style0 from "./LandingContent.vue?vue&type=style&index=0&id=0b40d768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports